import {
  ModalsStateContext,
  ModalsDispatchContext,
} from "./ConsoleModal.context";
import OldSiteNewModal from "components/Common/Modal/SiteNew/_SiteNew";
import SiteNewModal from "components/Common/Modal/SiteNew";
import CompleteMsgModal from "components/Common/Modal/CompleteMsg/CompleteMsg";
import GuideDownloadModal from "components/Common/Modal/GuideDownload/GuideDownload";
import useSiteNewModal from "src/hooks/Modal/useSiteNewModal";
import useCompleteMsgModal from "src/hooks/Modal/useCompleteMsgModal";
import useGuideDownloadModal from "src/hooks/Modal/useGuideDownloadModal";
import JoinPolicyModal from "components/Common/Modal/JoinPolicy/JoinPolicy.container";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";

interface IModalProvider {
  children: React.ReactNode;
}
const ConsoleModalsProvider = ({ children }: IModalProvider) => {
  const {
    showSiteNewModal,
    setShowSiteNewModal,
    serviceBillUid,
    setServiceBillUid,
    openSiteNewModal,
    hideSiteNewModal,
  } = useSiteNewModal();
  const { showMsgModal, setShowMsgModal, closeButtonMsg } =
    useCompleteMsgModal();
  const {
    showGuideDownloadModal,
    setShowGuideDownloadModal,
    // serviceList,
    // setServiceList,
    doNotOpenGuide,
    setDoNotOpenGuide,
    detailIndex,
    setDetailIndex,
    // openEco,
    goEcoAdmin,
    handleChangeGuide,
    closeButtonGuide,
  } = useGuideDownloadModal();

  const dispatch = {
    openSiteNewModal,
    hideSiteNewModal,
    setShowSiteNewModal,
    setServiceBillUid,
    closeButtonMsg,
    // setServiceList,
    setDetailIndex,
    setDoNotOpenGuide,
  };
  const state = { showSiteNewModal, serviceBillUid, detailIndex };
  const { isOciProduct } = useIsOciProduct();
  return (
    <ModalsDispatchContext.Provider value={dispatch}>
      <ModalsStateContext.Provider value={state}>
        {children}
        <JoinPolicyModal />
        {showSiteNewModal &&
          (isOciProduct ? (
            <OldSiteNewModal
              showSiteNewModal={showSiteNewModal}
              hideModal={() => setShowSiteNewModal(false)}
              // type={type}
              serviceBillUid={serviceBillUid}
            />
          ) : (
            <SiteNewModal
              showSiteNewModal={showSiteNewModal}
              hideModal={() => setShowSiteNewModal(false)}
              // type={type}
              serviceBillUid={serviceBillUid}
            />
          ))}
        {showMsgModal && (
          <CompleteMsgModal
            showMsgModal={showMsgModal}
            closeButtonMsg={closeButtonMsg}
          />
        )}
        {/* {getCookie({ name: "close30dGuide" }) !== "YES" && */}
        {showGuideDownloadModal && (
          <GuideDownloadModal
            showGuideDownloadModal={showGuideDownloadModal}
            handleChangeGuide={handleChangeGuide}
            goEcoAdmin={goEcoAdmin}
            closeButtonGuide={closeButtonGuide}
            doNotOpenGuide={doNotOpenGuide}
          />
        )}
      </ModalsStateContext.Provider>
    </ModalsDispatchContext.Provider>
  );
};

export default ConsoleModalsProvider;
